import { StockStatus } from '@gtpl/shared-models/common-models';

export class SPSAStockValuationReq{
    skuCodeId : number;
    saleOrderId : number;
    stockType : StockStatus;
    lotNumber : string;

    constructor(skuCodeId:number,saleOrderId:number,stockType:StockStatus,lotNumber:string) {
        this.skuCodeId = skuCodeId;
        this.saleOrderId = saleOrderId;
        this.stockType = stockType;
        this.lotNumber = lotNumber;
    }
}